import React, { useState } from "react";
import styles from "../../../../styles/pages/user/copyrwriterdashboard_dev/completed-video-details.module.scss";
import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  List,
  ListItem,
  Paper,
  Stack,
  Tab,
  Tabs,
  Tooltip,
  Typography,
  tooltipClasses,
  
} from "@mui/material";
import { useAutocomplete } from '@mui/base/useAutocomplete';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import videoPage from "../../../../public/assets/images/videoPageImg.png";
import CopyLinkIcon from "../../../../public/assets/icons/CopyLinkIcon";
import VideoButtonGroup from "../../../../components/VideoButtonGroup/VideoButtonGroup";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import VideoUpbuttonOptionPending from "../../../../components/VideoUpbuttonOption/VideoUpbuttonOptionPending";
import DownloadVideoIcon from "../../../../ui/Icons/DownloadVideoIcon";
import CopyIndexIcon from "../../../../public/assets/icons/CopyIndexIcon";
import VideoUrlIcon from "../../../../public/assets/icons/VideoUrlIcon";
import TextZoomIcon from "../../../../public/assets/icons/TextZoomIcon";
import { styled } from "@mui/system";
import FileAttachIcon from "../../../../public/assets/icons/FileAttachIcon";
import SolidCrrossIcon from "../../../../public/assets/icons/SolidCrrossIcon";
import noteIcon from "../../../../public/assets/images/noteIcon.svg";
import noteDateIcon from "../../../../public/assets/images/noteDateIcon.svg";
import noteDeleteIcon from "../../../../public/assets/images/noteDeleteIcon.svg";
import noteEyeIcon from "../../../../public/assets/images/noteEyeIcon.svg";
import { useParams } from "react-router";
import RevisedVideoaccordian from "../../../../components/CopywriterDashboard/Accordians/RevisedVideoAccordian";
import CopyBlueIcon from "../../../../public/assets/icons/CopyBlueIcon";
import NoteEditIcon from "../../../../public/assets/icons/NoteEditIcon";
import { Label } from "@mui/icons-material";
import Autocomplete from "../../../../components/CopywriterDashboard/PendingTitlingVideoPage/Autocomplete";
import DownloadArrowIcon from "../../../../public/assets/icons/DownloadArrowIcon";

const CopyWriterCompletedVideoDetails = () => {
  const { status } = useParams();

  const OriginalVideoTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} followCursor />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#fff",
      maxWidth: 237,
      borderRadius: "10px",
      color: "#000",
      boxShadow: "0px 0px 3px 0px rgba(0, 0, 0, 0.25)",
      padding: "9px 13px",
      [`& p`]: {
        color: "#000",
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "14px",
      },
    },
  }));

  const SocialVideoTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} followCursor />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#fff",
      maxWidth: 237,
      borderRadius: "10px",
      color: "#000",
      boxShadow: "0px 0px 3px 0px rgba(0, 0, 0, 0.25)",
      padding: "9px 13px",
      [`& p`]: {
        color: "#000",
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "14px",
      },
    },
  }));

  
  const [expanded, setExpanded] = React.useState(false);
  const [saved, setsaved] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [linkButton, setlinkButton] = useState({ youtube: false, post: false });
  const [videoRemoved, setvideoRemoved] = useState(false);
  const options = ['fail', 'funny', 'crash']

  
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleClickOpen1 = () => {
    setOpen1(true);
  };
  const handleClose1 = () => {
    setOpen1(false);
  };

  const handleClose = () => {
    setOpen(false);
    setsaved(false);
    setlinkButton(false);
  };
  const handleOpen = () => {
    setOpen(true);
    setTimeout(() => {
      setsaved(true);
    }, 2000);
  };

  const [tabValue, setTabValue] = React.useState(0);
  const handleChangeTab = (event, newValue) => {
    setTabValue(newValue);
  };

  const ownershipdata = [
    {
      head: "The person who filmed this video is ",
      content: "Me",
    },
    {
      head: "Are There People Appearing In the Video?  ",
      content: "No",
    },
    {
      head: "Did You Send/Submit/Upload This Video To a Website And/Or Social Media Account?   ",
      content: "No, I Did Not",
    },
    {
      head: "Did Anyone Reach You About Using This Video?   ",
      content: "No, You Are The First Company",
    },
    {
      head: "Did You Sign A Licensing Agreement For This Video With Another Company/Page?   ",
      content: "No, I Did Not",
    },
  ];

  function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  const PostInfoTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} placement="top-end" />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#fff",
      maxWidth: 199,
      borderRadius: "10px 10px 0 10px",
      color: "#000",
      boxShadow: "0px 0px 3px 0px rgba(0, 0, 0, 0.25)",
      padding: "10px",
      margin: "0 !important",
    },
  }));
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const dialogContainer = {
    [`.MuiDialog-container`]: {
      alignItems: "flex-start",

      [`.MuiDialog-paper`]: {
        marginTop: "62px",
        boxShadow: "none",
        borderRadius: "10px !important",
        [`.MuiDialogContent-root`]: {
          padding: "0",
        },
      },
    },
  };
  return (
    <Box className={styles.publishVideoPage}>
      <PerfectScrollbar className={styles.editorPublishScroll}>
        <Box className={styles.videoPageMain}>
          <Box className={styles.videoPageMainLeft}>
            <Box
              className={`${styles.videosection} ${
                videoRemoved && styles.videoRemoved
              }`}
            >
              <Box className={styles.videoSectionvideo}>
                <img src={videoPage} alt="" />
                <VideoUpbuttonOptionPending />
              </Box>

              <Box className={styles.videoLink}>
                <input
                  type="text"
                  placeholder="https://downloads.viralsnare.com/videos/2lKiIrdf5451df1JKYKpWpb.MOV"
                />
                <Button>
                  <CopyLinkIcon />
                </Button>
              </Box>

              <Box className={styles.videoButtonGroup}>
                <VideoButtonGroup />
              </Box>

              <Box className={styles.downloadVideo}>
                <Button>
                  <DownloadArrowIcon /> Download Video
                </Button>
                {/* <Button className={styles.confirmBtn} onClick={handleOpen}><RightBlackIcon /> Confirm Update</Button> */}
              </Box>
            </Box>
            {status === "revised" ? (
              <RevisedVideoaccordian title={'Metadata Successfully Revised on January 22, 2023 at 07:56 PM UTC.'}/>
            ) : (
              <Box className={styles.videoNotification}>
                <Typography variant="body1">
                  Video Titled On January 22, 2023 at 07:56 PM UTC.
                </Typography>
              </Box>
            )}
            {videoRemoved && (
              <Box className={`${styles.purchedBox} ${styles.greenBox}`}>
                <p>
                  Video pending titling since January 22, 2023 at 07:56 PM UTC.
                </p>
              </Box>
            )}
            <Paper
              className={`${styles.comWhiteBox} ${styles.titlePaperBox} ${
                videoRemoved && styles.videoRemoved
              } ${styles.vdoDetailsCard}`}
            >
              <Box className={styles.paperHeading}>
                <Typography variant="h2">
                  <span>Video Details</span>
                </Typography>
              </Box>
              <Box className={styles.vdodetailInner}>
                <Box className={styles.vdoUrlGroup}>
                  <Typography variant="caption" className={styles.formLabel}>
                    Public Post URL
                  </Typography>
                  <Box className={styles.videoInput}>
                    <input
                      type="text"
                      placeholder="Https://downloads.viralsnare.com/videos/2lKiIrdf5451df1JKYKpWpb.MOV"
                    />
                    <Button>
                      <CopyIndexIcon />
                    </Button>
                  </Box>
                </Box>
                <Box className={styles.titleGroup}>
                  <Typography variant="caption" className={styles.formLabel}>
                    Title
                  </Typography>
                  <Typography variant="body2" className={styles.formPara}>
                    Boy Jumped with the Umbrella and the Wind Almost Sent Him
                    Flying Too Far Away
                  </Typography>
                </Box>
                <Box className={styles.descriptionGroup}>
                  <Typography variant="caption" className={styles.formLabel}>
                    Description
                  </Typography>
                  <Typography variant="body2" className={styles.formPara}>
                    Fusce eget lacus non turpis porttitor gravida sit amet quis
                    tellus. Morbi tempus finibus elit in ultrices. Nunc sagittis
                    purus nisl, eu elementum risus faucibus vitae.
                    Integmolestie, ex sit amet semd mauris odimolestie, met semd
                    mauris odimolestie, ex sit amet semd maurier molestie, ex
                    sit amet semd mauris odidgfgo...{" "}
                    <Button>
                      <TextZoomIcon />
                    </Button>
                  </Typography>
                </Box>
                <Stack
                  direction={"row"}
                  alignItems={"center"}
                  className={styles.filmingGrid}
                >
                  <Box className={`${styles.filmingLocaton} ${styles.Col}`}>
                    <Typography variant="caption" className={styles.formLabel}>
                      Filming Location
                    </Typography>
                    <Typography variant="body2" className={styles.formPara}>
                      Los Angeles, California, United States
                    </Typography>
                  </Box>
                  <Box className={`${styles.filmingDate} ${styles.Col}`}>
                    <Typography variant="caption" className={styles.formLabel}>
                      Filming Date
                    </Typography>
                    <Typography variant="body2" className={styles.formPara}>
                      January 25, 2019
                    </Typography>
                  </Box>
                </Stack>
              </Box>
              {/* <Box className={styles.vdoFileList}>
                                    <InputLabel>Original Video File(s)</InputLabel>
                                    <Stack direction={'row'} alignItems={'center'} flexWrap={'wrap'} className={styles.addVdoFile}>
                                        <Box className={styles.linkBox}>
                                            <Typography variant='caption'>1.</Typography>
                                            <input type='text' value={value} onChange={(e) => setValue(e.target.value)} />
                                        </Box>
                                        <ButtonGroup>
                                            <Button onClick={addList}><AddPlusIcon /></Button>
                                            <PostInfoTooltip
                                                title={
                                                    <React.Fragment>
                                                        <Box className={styles.infoTooltip}>
                                                            <List disablePadding>
                                                                <ListItem disablePadding>
                                                                    <InputLabel>Added by:</InputLabel>
                                                                    <Typography variant='body2'>Partner/QC Agent/Member/Manager</Typography>
                                                                </ListItem>
                                                                <ListItem disablePadding>
                                                                    <InputLabel>Date:</InputLabel>
                                                                    <Typography variant='body2'>January 22, 2021 at 07:45 AM UTC</Typography>
                                                                </ListItem>
                                                            </List>
                                                        </Box>
                                                    </React.Fragment>
                                                }
                                            >
                                                <figure><InfoIcon /></figure>
                                            </PostInfoTooltip>
                                        </ButtonGroup>
                                    </Stack>
                                    <List disablePadding>
                                        {lisitem.map((data, index) => (
                                            <ListItem disablePadding key={index}>
                                                <Stack direction={'row'} alignItems={'center'} flexWrap={'wrap'} className={styles.addVdoFile}>
                                                    <Box className={styles.linkBox}>
                                                        <Typography variant='caption'>1.</Typography>
                                                        <input type='text' disabled {...data} />
                                                    </Box>
                                                    <ButtonGroup>
                                                        <Button>
                                                            <BtnTickIcon />
                                                        </Button>
                                                        <Button onClick={() => removeItem(index)}>
                                                            <BtnCrossIcon />
                                                        </Button>
                                                    </ButtonGroup>
                                                </Stack>
                                            </ListItem>
                                        ))}
                                    </List>
                                </Box> */}
              {/* <Box className={styles.vdoFileList}>
                                    <InputLabel>Social Media Post(s)</InputLabel>
                                    <Stack direction={'row'} alignItems={'center'} flexWrap={'wrap'} className={styles.addVdoFile}>
                                        <Box className={styles.linkBox}>
                                            <Typography variant='caption'>1.</Typography>
                                            <input type='text' value={socialValue} onChange={(e) => setsocialValue(e.target.value)} />
                                        </Box>
                                        <ButtonGroup>
                                            <Button onClick={addListsocial}><AddPlusIcon /></Button>
                                            <PostInfoTooltip
                                                title={
                                                    <React.Fragment>
                                                        <Box className={styles.infoTooltip}>
                                                            <List disablePadding>
                                                                <ListItem disablePadding>
                                                                    <InputLabel>Added by:</InputLabel>
                                                                    <Typography variant='body2'>Partner/QC Agent/Member/Manager</Typography>
                                                                </ListItem>
                                                                <ListItem disablePadding>
                                                                    <InputLabel>Date:</InputLabel>
                                                                    <Typography variant='body2'>January 22, 2021 at 07:45 AM UTC</Typography>
                                                                </ListItem>
                                                            </List>
                                                        </Box>
                                                    </React.Fragment>
                                                }
                                            >
                                                <figure><InfoIcon /></figure>
                                            </PostInfoTooltip>
                                        </ButtonGroup>
                                    </Stack>
                                    <List disablePadding>
                                        {socialLisitem.map((data, index) => (
                                            <ListItem disablePadding key={index}>
                                                <Stack direction={'row'} alignItems={'center'} flexWrap={'wrap'} className={styles.addVdoFile}>
                                                    <Box className={styles.linkBox}>
                                                        <Typography variant='caption'>1.</Typography>
                                                        <input type='text' disabled {...data} />
                                                    </Box>
                                                    <ButtonGroup>
                                                        <Button>
                                                            <BtnTickIcon />
                                                        </Button>
                                                        <Button onClick={() => removeItemsocial(index)}>
                                                            <BtnCrossIcon />
                                                        </Button>
                                                    </ButtonGroup>
                                                </Stack>
                                            </ListItem>
                                        ))}
                                    </List>
                                </Box> */}
            </Paper>
          </Box>

          <Box className={`${styles.videoColRight} `}>
            <Box className={styles.cmnboxborderd}>
              <Box
                className={`${styles.pageMainAlert} ${styles.pageMainAlertTwo}`}
              >
                <Typography variant="h5">Team Notes</Typography>
                <Button className={styles.btnClose}>
                  <SolidCrrossIcon />
                </Button>
                <Typography>
                  Fusce eget lacus non turpis porttitor gravida sit amet quis
                  tellus. Morbi tempus finibus elit in ultrices. Nunc sagittis
                  purus nisl, eu elementum risus faucibus vita. Integer
                  molestie, ex sit amet semper aliquam, mauris odio dignissim
                  velit, suscipit feugiat massa est varius lectus. Phasellus
                  euismod lacinia tortor ac finibus. Maecenas semper consectetur
                  venenatis. Nullam eget felis gravida, consectetur lacus nec,
                  fermentum metus. Suspendisse ac tellus...
                </Typography>
              </Box>
            </Box>

            <Box className={styles.commonAccordianWrapper}>
              <Accordion disabled>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Box
                    className={`${styles.accordianHeader} ${styles.accordianHeaderTwo}`}
                  >
                    <Typography>Team Messages</Typography>
                    <Box className={`${styles.btnGroup} ${styles.btnGroupTwo}`}>
                      <Button>Admin</Button>
                      <Button>QC Agent</Button>
                      <Button>Editor</Button>
                    </Box>
                  </Box>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    Fusce eget lacus non turpis porttitor gravida sit amet quis
                    tellus. Morbi tempus finibus elit in ultrices. Nunc sagittis
                    purus nisl, eu elementum risus faucibus vita. Integer
                    molestie, ex sit amet semper aliquam, mauris odio dignissim
                    velit, suscipit feugiat massa est varius lectus. Phasellus
                    euismod lacinia tortor ac finibus. Maecenas semper
                    consectetur venenatis. Nullam eget felis gravida,
                    consectetur lacus nec, fermentum metus. Suspendisse ac
                    tellus...
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </Box>

            <Box className={styles.videoMetaData}>
              <Typography variant="h3">Video Metadata</Typography>
              <Box className={styles.metadataWrap}>
                <Box className={`${styles.titleBox} `}>
                  <Typography variant="h4"><span>Title</span>  <NoteEditIcon color='#111AE9'/> </Typography>
                  <input
                    type="text"
                    value={
                      "Dogs running with human"
                    }
                  />
                </Box>
                <Box className={`${styles.descriptionBox} `}>
                  <Typography variant="h4"><span>Description</span>  <NoteEditIcon color='#111AE9'/></Typography>
                  <textarea value={'The dogs were running away then my husband starting running aft'}/>
                </Box>
                <Box className={`${styles.tagBox}`}>
                  <Typography variant="h4"><span>Tags</span>  <NoteEditIcon color='#111AE9'/></Typography>
                <Autocomplete/>
                </Box>
              </Box>
            </Box>

            {status ==="revised" && <Box className={`${styles.commonAccordianWrapper} ${styles.editing_history_wrapper}`}>
              <Accordion >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Box
                    className={`${styles.accordianHeader} ${styles.accordianHeaderTwo}`}
                  >
                    <Typography>Editing History</Typography>
                    
                  </Box>
                </AccordionSummary>
                <AccordionDetails>
                 <Box className={styles.commonBox}>
                    <Typography variant="h5">
                    Title amended on March 25, 2022 at 15:25:29 AM UTC
                    </Typography>
                    <Typography><Typography variant="caption">Revised:</Typography>this is a title written by a copywriter.  </Typography>  
                    <Typography><Typography variant="caption">Original:</Typography>this is an amended titled written by a copywriter.   </Typography>  
                 </Box>
                 <Box className={`${styles.commonBox} ${styles.descripTion}`}>
                    <Typography variant="h5">
                    Description amended on March 25, 2022 at 15:25:29 AM UTC
                    </Typography>
                    <Typography><Typography variant="caption">Revised:</Typography> Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.  </Typography>  
                    <Typography><Typography variant="caption">Original:</Typography> Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus</Typography>  
                 </Box>
                 <Box className={styles.commonBox}>
                    <Typography variant="h5">
                    Title amended on March 25, 2022 at 15:25:29 AM UTC
                    </Typography>
                    <Typography><Typography variant="caption">Revised:</Typography>this is a title written by a copywriter.  </Typography>  
                    <Typography><Typography variant="caption">Original:</Typography>this is an amended titled written by a copywriter.   </Typography>  
                 </Box>
                 <Box className={styles.commonBox}>
                    <Typography variant="body1">
                    Title, description & tags were added on March 24, 2022 at 10:52:33 AM UTC
                    </Typography>
                 </Box>
                </AccordionDetails>
              </Accordion>
            </Box>}
          </Box>
        </Box>
      </PerfectScrollbar>

      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={open}
        onClick={handleClose}
        className={styles.backDropBarWrap}
      >
        {saved ? (
          <Box className={styles.backDropBarSucces}>
            <Typography variant="body1">
              Metadata updated Successfully
            </Typography>
          </Box>
        ) : (
          <Box className={styles.backDropBar}>
            <CircularProgress color="inherit" />
            <Typography variant="body1">Saving</Typography>
          </Box>
        )}
      </Backdrop>
    </Box>
  );
};

export default CopyWriterCompletedVideoDetails;
